export default __webpack_public_path__ + "0810df06515b87897109efa9947a76e3.png";